import { MenuItem } from '@material-ui/core';
import React from 'react';

import useTrafficSelectable from 'core/hooks/useTrafficSelectable';
import { InputField, InputFieldProps } from 'Elements/Form';

export default function TrafficSelect(props: InputFieldProps) {
  const trafficTypes = useTrafficSelectable();

  return (
    <InputField
      {...props}
      select
      fullWidth
      variant="outlined"
      placeholder="Valitse"
      margin="normal"
      InputLabelProps={{
        shrink: true
      }}
    >
      {trafficTypes
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(traffic => (
          <MenuItem key={traffic.id} value={traffic.id}>
            {traffic.name}
          </MenuItem>
        ))}
    </InputField>
  );
}
